<!--
  Different types of cards
  - basic carousel
  - button only
  - marketing
  - gradient
 -->

<!-- Carousel Card -->
<div
  *ngIf="cardType === 'carousel'"
  class="card-container"
  data-aos="fade-up"
  data-aos-duration="1000"
  data-aos-delay="100"
  data-aos-once="true"
  data-aos-easing="ease-in-out"
>
  <dx-gallery
    #gallery
    id="gallery"
    [dataSource]="cardInfo"
    [loop]="true"
    [slideshowDelay]="7000"
    [animationDuration]="800"
    [showNavButtons]="false"
    [showIndicator]="true"
  >
    <div *dxTemplate="let galleryItem of 'item'" class="justify-content-center">
      <div class="quote-container">
        <h3 class="quote text-wrap m-0">{{ galleryItem.quote }}</h3>
        <div class="quoter-continer">
          <p class="quoter-bold white m-0">
            {{ cardInfo[cardIndex].quoterBold }}
          </p>
          <p class="quoter text-wrap text-center m-0">
            {{ galleryItem.quoter }}
          </p>
        </div>
      </div>
    </div>
  </dx-gallery>
</div>

<!-- Button Card -->
<div
  *ngIf="cardType === 'button'"
  class="button-card-container"
  data-aos="fade-up"
  data-aos-duration="1000"
  data-aos-delay="100"
  data-aos-once="true"
  data-aos-easing="ease-in-out"
>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <h3 class="quote white text-center">{{ buttonCard?.copy }}</h3>
    <p *ngIf="buttonCard?.subCopy" class="sub-quote">
      {{ buttonCard.subCopy }}
    </p>
    <app-button
      [buttonColor]="buttonCard?.button?.color"
      [buttonIcon]="buttonCard?.button?.icon"
      [buttonLink]="buttonCard?.button?.link"
      [buttonText]="buttonCard?.button?.text"
      [buttonType]="buttonCard?.button?.type"
    >
    </app-button>
  </div>
</div>
